import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

// Import theme module
import TYPOGRAPHY from '../../../themes/Typography'
import { px2Rem } from '../../../themes/Mixins'
import COLORS from '../../../themes/Colors'

// Defined styled component for MainTitle
const Title = styled.h1`
  margin: 0;
  font-weight: 300;
  text-align: center;
  line-height: normal;
  white-space: pre-line;
  color: ${COLORS.white};
  padding: 0 ${px2Rem(20)};
  font-family: ${TYPOGRAPHY.TYPE.base};
  font-size: ${TYPOGRAPHY.SIZE.xxSmall};

  @media (min-width: 375px) and (max-width: 767px) {
    font-size: ${TYPOGRAPHY.SIZE.xSmall};
  };

  @media (min-width: 768px) {
    font-size: ${TYPOGRAPHY.SIZE.xxLarge};
  };
`

//Defined component MainTitle
const MainTitle = ({ title, customStyle }) => {
  return (
    <Title style={customStyle}>
      {title}
    </Title>
  )
}

MainTitle.propTypes = {
  title: PropTypes.string
}

MainTitle.defaultProps = {
  title: ''
}

export default MainTitle




// WEBPACK FOOTER //
// ./src/components/sections/banner/MainTitle.js